import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetExchangeRates from '../../common/category/useGetExchangeRates'
import { Element } from '../../common/html/element'
import { Image } from '../../common/image'
import currencyConversionIcon from '../../common/order/customPrice/currencyConversion.svg'
import { Tooltip } from '../../common/tooltip'
import { formatCurrency, formatCurrencyFollowLocale } from '../../helpers/value'
import { CURRENCY } from '../../utils/currency'
import classes from '../index.module.scss'

const Subtotal = ({ value, isSub }) => {
  const { exchangeRates } = useGetExchangeRates()
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <div className={`dFlex ${classes.itemData}`}>
      <div className={classes.column1} />
      <Element className="dFlex">
        <div className={`fw600 ${classes.widthTitle}`}>
          <Translate
            value={`cartAndOrders.orderInformation.${
              isSub ? 'subTotal' : 'price'
            }`}
          />
          :
        </div>

        <div className="dFlex alignItemsCenter">
          {formatCurrency(
            value,
            CURRENCY.USD,
            CURRENCY.VND,
            exchangeRates,
            locale,
          )}
          <Tooltip
            zIndex={13}
            contentClass="dFlex"
            tooltipContent={formatCurrencyFollowLocale(
              value,
              CURRENCY.USD,
              locale,
            )}
          >
            <Image
              src={currencyConversionIcon}
              alt="changeCurrency"
              style={{ width: 15, height: 15, marginLeft: 7 }}
            />
          </Tooltip>
        </div>
      </Element>
    </div>
  )
}

Subtotal.propTypes = {
  value: PropTypes.number,
}

export default Subtotal
